import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import "./Style.css";

const FishMob = () => {
  let history = useHistory();
  const { t } = useTranslation();
  const languageText = localStorage.getItem("lancode");
  const menuDetails = useSelector((state) => state.landing.menuDetails);

  const getMenus = (cat) => {
    const menuMain =
      menuDetails &&
      menuDetails.data &&
      menuDetails.data.filter((item) => item.categoryEN == cat);
    const subCategory =
      menuMain && menuMain.length > 0 && menuMain[0].subCategory;
    return subCategory;
  };
  return (
    <>
      <div className="bg-HeaderMobPages">
        <button onClick={()=>history.goBack()}>
        {t("Back.label")}
        </button>
        <h4>
          <a href="/fish">{t("Fish.label")}</a>
        </h4>
        <ul>
          {getMenus("fish") &&
            getMenus("fish").length > 0 &&
            getMenus("fish").map((item) => {
              return (
                <li>
                  <a href={"/fish/" + item.subCategorySlug}>
                    {languageText === "en"
                      ? item.subCategoryEN
                      : item.subCategoryTH}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
    </>
  );
};

export { FishMob as FishMob };
